import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { localize } from "@/lib/localize";

export const CATEGORY_ORDER = ["mission", "centre", "programme", "incubation"];

let cache = null;
let inflight = null;

function load() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get("/initiatives").then((r) => {
      cache = r.data;
      return cache;
    });
  }
  return inflight;
}

/** Fetch (once) and localize all initiatives; returns { items, byCategory }. */
export function useInitiatives() {
  const { i18n } = useTranslation();
  const [raw, setRaw] = useState(cache || []);

  useEffect(() => {
    load().then(setRaw).catch(() => {});
  }, []);

  const items = raw.map((d) => localize(d, i18n.language, ["title", "short", "tagline", "summary"]));
  const byCategory = CATEGORY_ORDER.reduce((acc, c) => {
    acc[c] = items.filter((i) => i.category === c);
    return acc;
  }, {});
  return { items, byCategory };
}
